import PinnacleLogo from 'app/icons/pinnacle-logo.svg';
import Bet365Logo from 'app/icons/bet365-logo.svg';
import PandaoddsLogo from 'app/icons/pandaodds-logo.svg';
import GGBetLogo from 'app/icons/ggbet-logo.svg';
import Bet366Logo from 'app/icons/bet366-logo.svg';
import GamdomLogo from 'app/icons/gamdom-logo.svg';
import MaxbetLogo from 'app/icons/maxbet-logo.svg';
import FonbetLogo from 'app/icons/fonbet-logo.svg';

const COMPETITORS_NAME: Record<CompetitorSlug, CompetitorName> = {
  pinnacle: 'Pinnacle',
  bet365: 'Bet365',
  pandaodds: 'PandaOdds 1.0',
  'pandaodds-limited': 'PandaOdds 1.0',
  'pandaodds-helper-model': 'Helper Model',
  ggbet: 'GGbet',
  bet366: 'Bet366',
  gamdom: 'Gamdom',
  maxbet: 'Maxbet',
  fonbet: 'Fonbet'
};

const COMPETITORS_LOGO: Record<CompetitorSlug, SVG> = {
  pinnacle: PinnacleLogo,
  bet365: Bet365Logo,
  pandaodds: PandaoddsLogo,
  'pandaodds-limited': PandaoddsLogo,
  'pandaodds-helper-model': PandaoddsLogo,
  ggbet: GGBetLogo,
  bet366: Bet366Logo,
  gamdom: GamdomLogo,
  maxbet: MaxbetLogo,
  fonbet: FonbetLogo
};

const MATCH_PAGE_COMPETITORS: Record<CompetitorSlug, MatchStatus[]> = {
  pinnacle: ['set_up', 'pending', 'pre_match', 'live'],
  bet365: ['set_up', 'pending', 'pre_match', 'live'],
  pandaodds: ['live'],
  'pandaodds-limited': ['live'],
  'pandaodds-helper-model': ['live'],
  ggbet: ['set_up', 'pending', 'pre_match', 'live'],
  bet366: ['set_up', 'pending', 'pre_match', 'live'],
  gamdom: ['set_up', 'pending', 'pre_match', 'live'],
  maxbet: ['set_up', 'pending', 'pre_match', 'live'],
  fonbet: ['set_up', 'pending', 'pre_match', 'live']
};

const EVENT_LIST_COMPETITORS: CompetitorSlug[] = [
  'pinnacle',
  'bet366',
  'ggbet',
  'maxbet',
  'fonbet'
];

const MONITORING_COMPETITORS: CompetitorSlug[] = [
  'pinnacle',
  'bet366',
  'ggbet',
  'maxbet',
  'fonbet'
];

// This is the only one that really needs to be kept in order
const COMPETITORS_ORDER: CompetitorSlug[] = [
  'pinnacle',
  'bet365',
  'bet366',
  'ggbet',
  'gamdom',
  'maxbet',
  'fonbet',
  'pandaodds',
  'pandaodds-limited',
  'pandaodds-helper-model'
];

const TOGGLABLE_COMPETITORS: CompetitorSlug[] = [
  'pinnacle',
  'bet366',
  'ggbet',
  'maxbet',
  'fonbet',
  'pandaodds'
];

const MARKET_TEMPLATES_COMPETITORS = [
  'winner-2-way',
  'winner-3-way',
  'kill-over-under',
  'kill-handicap',
  'map-handicap',
  'map-handicap-1',
  'map-handicap-2',
  'map-handicap-3',
  'map-handicap-4',
  'map-over-under',
  'round-over-under',
  'round-handicap',
  'tower-over-under',
  'drake-over-under',
  'nashor-over-under'
];

const MONITORING_MARKETS: `${string}__${BlueprintEventType}`[] = [
  'winner-2-way__match',
  'winner-3-way__match',
  'map-handicap__match',
  'map-over-under__match',
  'winner-2-way__game',
  'kill-handicap__game',
  'kill-over-under__game',
  'round-handicap__game',
  'round-over-under__game',
  'tower-over-under__game',
  'drake-over-under__game',
  'nashor-over-under__game'
];

const MARKET_CATEGORY_COMPETITORS = ['winner', 'kill', 'main', 'round', 'tower', 'nashor', 'drake'];

export {
  MATCH_PAGE_COMPETITORS,
  EVENT_LIST_COMPETITORS,
  TOGGLABLE_COMPETITORS,
  COMPETITORS_NAME,
  COMPETITORS_LOGO,
  COMPETITORS_ORDER,
  MARKET_TEMPLATES_COMPETITORS,
  MARKET_CATEGORY_COMPETITORS,
  MONITORING_MARKETS,
  MONITORING_COMPETITORS
};
